/* eslint-disable no-undef */
import React from 'react';
import { useEffect, useState } from 'react';
import axios from 'axios';
import {
  defaultConsentState,
  formatDate,
  formatPrice,
  getCookiebotConsentState,
} from '../utils/helpers';
import { countrySettings } from '../utils/country-settings';

const SingleBooking = () => {
  const [countryCode, setCountryCode] = useState('');
  const [parkServices, setParkServices] = useState(null);
  const [caravanPrice, setCaravanPrice] = useState(null);
  const [categoriesWithBooking, setCategoriesWithBooking] = useState([]);
  const [cookieConsent, setCookieConsent] = useState(defaultConsentState);

  /**
   * The CookiebotOnLoad event is triggered at the same
   * time as the window.onload event when the user’s consent
   * has been loaded – either when the user submits consent or
   * when the user navigates to a page where consent has
   * already been submitted.
   */
  useEffect(() => {
    window.addEventListener(
      'CookiebotOnLoad',
      () => {
        setCookieConsent(getCookiebotConsentState());
      },
      false,
    );
  }, []);

  let {
    bookingParkId,
    language,
    translations,
    urls,
    themeUrl,
    cottages,
    maintenance,
  } = pluginGlobals;

  if (
    !bookingParkId &&
    bookingPageSelectedPark &&
    bookingPageSelectedPark > 0
  ) {
    bookingParkId = bookingPageSelectedPark;
  }

  let maintenanceAvailable = true;
  if (typeof maintenance !== 'undefined' && maintenance && maintenance.status) {
    maintenanceAvailable = maintenance.status === 'available';
  }

  if (
    typeof bookingPageMaintenanceAvailable !== 'undefined' &&
    bookingPageMaintenanceAvailable &&
    bookingPageMaintenanceAvailable !== ''
  ) {
    maintenanceAvailable = bookingPageMaintenanceAvailable === 'available';
  }

  const today = new Date();
  const endDate = new Date().setDate(today.getDate() + 30);
  const bestparkApiParkUrl = `https://api.bestpark.com/parks/`;

  useEffect(() => {
    if (!bookingParkId || !language) return;

    axios
      .get(`${bestparkApiParkUrl}${bookingParkId}?data=booking`)
      .then((response) => {
        if (response.data) {
          setCountryCode(response.data.countryCode);
          setParkServices({
            serviceEntryPrice: response.data.serviceEntryPrice,
            availableServices: {
              caravan: response.data.caravan,
              cottages: response.data.categories,
              maintenance: response.data.maintenance,
            },
          });

          const parkSlotCategories = response.data.parkSlotCategories;

          // Get all categories with hasOwnBookingPage = true
          if (parkSlotCategories) {
            setCategoriesWithBooking(
              parkSlotCategories
                .filter((category) => category.hasOwnBookingPage)
                .sort((a, b) => (a.sort > b.sort ? 1 : -1)),
            );
          }
        } else {
          setCountryCode('FI');
          setParkServices(null);
        }
      });

    axios
      .get(
        `${bestparkApiParkUrl}${bookingParkId}/prices?startDate=${formatDate(
          today,
        )}&endDate=${formatDate(endDate)}`,
      )
      .then((response) => {
        const dates = Object.values(response.data.result);
        const prices = dates.map((date) => {
          return date.price;
        });
        const min = Math.min.apply(null, prices);
        setCaravanPrice(min);
      });
  }, [bookingParkId, language]);

  const services = parkServices ? parkServices.availableServices : {};
  const currencySymbol = countryCode
    ? countrySettings[countryCode].currencySymbol
    : '';
  const cookieConsentUrlParams = new URLSearchParams(cookieConsent);

  return (
    <>
      <h2>{translations.bookTitleText}</h2>
      {parkServices?.availableServices?.caravan && (
        <a href={`${urls.booking}/${bookingParkId}?${cookieConsentUrlParams}`}>
          <span>
            <img src={`${themeUrl}/img/parks/caravan.svg`} alt='' />
          </span>
          <span
            style={{
              paddingTop: !services || !services.maintenance ? '11px' : '',
              display: !services || !services.maintenance ? 'inline-block' : '',
            }}
          >
            {translations.bookCtaText}
          </span>
          {caravanPrice ? (
            <>
              <br />
              {translations.fromText}{' '}
              {formatPrice(caravanPrice, currencySymbol)}
            </>
          ) : null}
        </a>
      )}
      {maintenanceAvailable && (
        <a
          href={`${urls.maintenanceBooking}/${bookingParkId}?${cookieConsentUrlParams}`}
        >
          <span>
            <img
              src={`${themeUrl}/img/parks/maintenance.svg`}
              alt=''
              style={{ width: '22px' }}
            />
          </span>
          <span
            style={{
              paddingTop: !services || !services.maintenance ? '11px' : '',
              display: !services || !services.maintenance ? 'inline-block' : '',
            }}
          >
            {translations.bookMaintenanceCtaText}
          </span>
          {parkServices && parkServices.serviceEntryPrice ? (
            <>
              <br />
              {translations.fromText}{' '}
              {formatPrice(parkServices.serviceEntryPrice, currencySymbol)}
            </>
          ) : null}
        </a>
      )}
      {categoriesWithBooking.length > 0 &&
        categoriesWithBooking.map((category) => {
          // We need category id, category name and category price for the link
          const categoryId = category.id;
          if (categoryId) {
            const linkText =
              category.translations.find(
                (translation) => translation.languageCode === language,
              )?.name ?? '';

            // Price can be set from slot category editor in admin,
            // where SLOT ADD ON PRICE means category.price and
            // SLOT PRICE OVERRIDE means category.priceOveride.
            const categoryPrice =
              category.priceOveride || category.price + caravanPrice;

            return (
              <a
                href={`${urls.cottageBooking}/${bookingParkId}/${categoryId}?${cookieConsentUrlParams}`}
              >
                <span>
                  <img src={`${themeUrl}/img/parks/categories.svg`} alt='' />
                </span>
                <span>{linkText}</span>
                <br />
                {translations.fromText}{' '}
                {formatPrice(categoryPrice, currencySymbol)}
              </a>
            );
          } else {
            return <></>;
          }
        })}
    </>
  );
};

export default SingleBooking;
